import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import api from "../../services/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Meta from "../../components/Meta";
import { useHistory } from "react-router-dom";

function StepFour({ prevStep, values }) {
  const [loading, setLoading] = useState(false);

  const [imgPerfil, setImgPerfil] = useState(null);
  const [imgComprovante, setImgComprovante] = useState(null);
  const [imgFrente, setImgFrente] = useState(null);
  const [imgVerso, setImgVerso] = useState(null);
  const [imgCpf, setImgCpf] = useState(null);
  const [imgContrato, setImgContrato] = useState(null);
  const [imgCtps, setImgCtps] = useState(null);
  const [imgHolerite, setImgHolerite] = useState(null);

  const history = useHistory();

  const {
    nome, cpf, email, nomeSocial, dtNascimento, sexo, estadoCivil,
    dependente, tipoDoc, docIdentificacao, orgEmissor, dtEmissao,
    escolaridade, ultimaSerie, estudante, deficiente,
    nomePai, nomeMae, naturalidade, nacionalidade,
    fone1, fone2, renda, rendaFamiliar,
    estado, cidade, bairro, logradouro, cep, numero,
    cnpj, razaoSocial, contato,
    ctps, serie, situacao, pis_pasep,
    cargo, dtAdmissao, dtDemissao,
  } = values;

  const submitFormData = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      // =========================
      // VALIDAÇÃO DE ARQUIVOS (NÃO QUEBRA BACKEND)
      // =========================
      const files = [
        { file: imgPerfil, name: "Foto 3x4" },
        { file: imgComprovante, name: "Comprovante de residência" },
       // { file: imgCpf, name: "CPF" },
        { file: imgFrente, name: "(RG) Frente do documento identificação com foto" },
        { file: imgVerso, name: "(RG) Verso do documento identificação" },
       // { file: imgContrato, name: "Contrato de trabalho" },
        { file: imgCtps, name: "CTPS Digital" },
        { file: imgHolerite, name: "Holerite/Contra-Cheque" },
      ];

      for (const f of files) {
        if (!f.file) {
          toast.error(`${f.name} é obrigatório`);
          setLoading(false);
          return;
        }

        if (f.file.size > 5 * 1024 * 1024) {
          toast.error(`${f.name} deve ter no máximo 5MB`);
          setLoading(false);
          return;
        }
      }

      // =========================
      // FORM DATA
      // =========================
      const formData = new FormData();

      formData.append("docPerfil", imgPerfil);
      formData.append("docComprovante", imgComprovante);
      //formData.append("docCpf", imgCpf);
      formData.append("docFrente", imgFrente);
      formData.append("docVerso", imgVerso);
      //formData.append("docContrato", imgContrato);
      formData.append("docCtps", imgCtps);
      formData.append("docHolerite", imgHolerite);

      // dados normais (igual seu código)
      formData.append("email", email);
      formData.append("nome", nome);
      formData.append("cpf", cpf);
      formData.append("nomeSocial", nomeSocial);
      formData.append("dtNascimento", dtNascimento);
      formData.append("sexo", sexo);
      formData.append("estadoCivil", estadoCivil);
      formData.append("dependente", dependente);
      formData.append("tipoDoc", tipoDoc);
      formData.append("docIdentificacao", docIdentificacao);
      formData.append("orgEmissor", orgEmissor);
      formData.append("dtEmissao", dtEmissao);
      formData.append("escolaridade", escolaridade);
      formData.append("ultimaSerie", ultimaSerie);
      formData.append("estudante", estudante);
      formData.append("deficiente", deficiente);
      formData.append("nomePai", nomePai);
      formData.append("nomeMae", nomeMae);
      formData.append("naturalidade", naturalidade);
      formData.append("nacionalidade", nacionalidade);
      formData.append("fone1", fone1);
      formData.append("fone2", fone2);
      formData.append("renda", renda);
      formData.append("rendaFamiliar", rendaFamiliar);
      formData.append("estado", estado);
      formData.append("cidade", cidade);
      formData.append("bairro", bairro);
      formData.append("logradouro", logradouro);
      formData.append("cep", cep);
      formData.append("numero", numero);
      formData.append("cnpj", cnpj);
      formData.append("razaoSocial", razaoSocial);
      formData.append("contato", contato);
      formData.append("ctps", ctps);
      formData.append("serie", serie);
      formData.append("situacao", situacao);
      formData.append("pis_pasep", pis_pasep);
      formData.append("cargo", cargo);
      formData.append("dtAdmissao", dtAdmissao);
      formData.append("dtDemissao", dtDemissao);

      // ❌ NÃO DEFINA Content-Type (IMPORTANTE)
      const { data } = await api.put("/api/users/userdx", formData);

      toast.success("Cadastro enviado com sucesso!");
      setTimeout(() => history.push("/"), 1200);

    } catch (error) {
      const err =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;

      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <Meta />

      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg">
                <div className="p-5">

                  {/* ===== HEADER ORIGINAL (NÃO MEXI) ===== */}
                  <div className="text-center">
                    <h5 className="h5 text-gray-900 mb-4">
                      CADASTRO CLIENTE <br />
                      <small style={{ fontSize: "14px" }}>
                        Trabalhador do Comércio
                      </small>
                    </h5>

                    <br />

                    <div className="card card-timeline px-1 border-none mb-5">
                      <ul className="bs4-order-tracking">
                        <li className="step active">
                          <div><i className="fas fa-user"></i></div>
                          <label style={{ fontSize: "10px" }}>pessoal</label>
                        </li>
                        <li className="step active">
                          <div><i className="far fa-envelope-open"></i></div>
                          <label style={{ fontSize: "10px" }}>endereço</label>
                        </li>
                        <li className="step active">
                          <div><i className="far fa-address-card"></i></div>
                          <label style={{ fontSize: "10px" }}>profissional</label>
                        </li>
                        <li className="step active">
                          <div><i className="fas fa-file-upload"></i></div>
                          <label style={{ fontSize: "10px" }}>documentação</label>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* ===== FORM (IGUAL AO SEU ORIGINAL) ===== */}
                  <form className="user" onSubmit={submitFormData}>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label>FOTO 3X4</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docPerfil"
                          onChange={(e) => setImgPerfil(e.target.files[0])}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.pdf,.PDF"
                        />

                        <p className="text-dark mb-0" style={{ fontSize: "11px" }}>
                          A imagem deve estar na posição <b>retrato</b> e a
                          pessoa deve estar sozinha na foto. Na foto a pessoa
                          não deve usar acessórios tais como: óculos, boné,
                          chapéu ou qualquer outro que dificulte a
                          indentificação. <b>Tamanho máximo 5MB</b>
                        </p>
                      </div>

                      <div className="col-sm-6">
                        <label>COMPROVANTE DE RESIDÊNCIA</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docComprovante"
                          onChange={(e) => setImgComprovante(e.target.files[0])}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.PDF,.pdf"
                        />

                        <p className="text-dark mb-0" style={{ fontSize: "11px" }}>
                          Será aceito somente comprovante dos últimos <b>3 meses</b>.
                          <b> Tamanho máximo 5MB</b>
                        </p>
                      </div>
                    </div>

                    <hr className="mt-4 mb-5" />

                   

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label>DOCUMENTO DE IDENTIFICAÇÃO OFICIAL - FRENTE</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docFrente"
                          onChange={(e) => setImgFrente(e.target.files[0])}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.pdf,.PDF"
                        />

                        <p className="text-dark mb-0" style={{ fontSize: "11px" }}>
                         <b>Tamanho máximo 5MB</b>
                        </p>
                      </div>

                      <div className="col-sm-6">
                        <label>RG DOCUMENTO DE IDENTIFICAÇÃO OFICIAL - VERSO</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docVerso"
                          onChange={(e) => setImgVerso(e.target.files[0])}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.pdf,.PDF"
                        />
                         <p className="text-dark mb-0" style={{ fontSize: "11px" }}>
                         <b>Tamanho máximo 5MB</b>
                        </p>
                      </div>
                    </div>

                    <hr className="mt-4 mb-5" />

                   
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <label>CARTEIRA DE TRABALHO DIGITAL</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docCtps"
                          onChange={(e) => setImgCtps(e.target.files[0])}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.pdf,.PDF"
                        />

                        <p className="text-dark" style={{ fontSize: "11px" }}>
                          <b>CTPS Digital </b>.
                          <b> Tamanho máximo 5MB</b>
                        </p>
                      </div>

                      <div className="col-sm-6">
                        <label>CONTRA-CHEQUE/ HOLERITE</label>

                        <input
                          type="file"
                          className="form-control-file"
                          name="docHolerite"
                          onChange={(e) => setImgHolerite(e.target.files[0])}
                          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.pdf,.PDF"
                        />

                        <p className="text-dark" style={{ fontSize: "11px" }}>
                          Contra-cheque/Holerite mais recente emitido pela empresa.
                          <b> Tamanho máximo 5MB</b>
                        </p>
                      </div>
                    </div>

                    <hr className="mt-4" />

                    <Button
                      onClick={prevStep}
                      disabled={loading}
                      className="btn btn-warning btn-user btn-block"
                    >
                      Anterior
                    </Button>

                    <Button
                      type="submit"
                      disabled={loading}
                      className="btn btn-primary btn-user btn-block"
                    >
                      {loading ? (
                        <>
                          <Spinner size="sm" animation="border" /> Enviando...
                        </>
                      ) : (
                        "Continuar"
                      )}
                    </Button>

                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StepFour;